'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2; // Admin panel needs to look at all users
// Users + goals + all their data
/* eslint-disable */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

var _admin = require('redux/modules/admin');

var _adminModuleApps = require('redux/modules/adminModuleApps');

var _adminGoals = require('redux/modules/adminGoals');

var _adminStrategies = require('redux/modules/adminStrategies');

var _adminBarriers = require('redux/modules/adminBarriers');

var _reduxConnect = require('redux-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Admin, panel which admin has access to upon
 * login, this panel enables the admin to obtain
 * important information about all users using Reboot
 * Kids
 */


// 33e0ff default active color
var Admin = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    // if (!isUserIDsLoaded(getState())) {
    promises.push(dispatch((0, _admin.loadUserID)()));
    // }

    // if (!isModuleAppsLoaded(getState())) {
    promises.push(dispatch((0, _adminModuleApps.loadModuleApps)(getState())));
    // }

    // if (!isGoalsLoaded(getState())) {
    promises.push(dispatch((0, _adminGoals.loadGoals)()));
    // }

    // if (!isStrategiesLoaded(getState())) {
    promises.push(dispatch((0, _adminStrategies.loadStrategies)()));
    // }

    // if (!isBarriersLoaded(getState())) {
    promises.push(dispatch((0, _adminBarriers.loadBarriers)()));
    // }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, adminPage: state.adminState.adminPage };
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Admin, _Component);

  function Admin() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Admin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Admin.__proto__ || (0, _getPrototypeOf2.default)(Admin)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Admin, [{
    key: 'render',
    value: function render() {
      var styles = require('./Admin.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.adminPage },
        _react2.default.createElement(_components.AdminSidebar, null),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 2, sm: 3, xs: 2, lg: 2 },
          '\xA0'
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 10, sm: 9, xs: 10, lg: 10, className: styles.adminPanel },
          this.props.adminPage === 'admincreateuser' && _react2.default.createElement(_components.AdminCreateUser, null),
          this.props.adminPage === 'adminusers' && _react2.default.createElement(_components.AdminUsers, null),
          this.props.adminPage === 'adminmodules' && _react2.default.createElement(_components.AdminModules, null),
          this.props.adminPage === 'admingoals' && _react2.default.createElement(_components.AdminGoals, null),
          this.props.adminPage === 'adminbarriers' && _react2.default.createElement(_components.AdminBarriers, null),
          this.props.adminPage === 'adminstrategies' && _react2.default.createElement(_components.AdminStrategies, null)
        )
      );
    }
  }]);
  return Admin;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  adminPage: _propTypes2.default.string
}, _temp2)) || _class) || _class);

/* eslint-enable */

exports.default = Admin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/Admin.js
// module id = 1270
// module chunks = 0